// extracted by mini-css-extract-plugin
export default {"controls":"hKNVFY","monthControls":"QEZBWx","monthButton":"pgdLwu","back":"uSfWii","month":"n5kPUI","loading":"TSvqg6","next":"J8AvVb","days":"ZmBPei"};